import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { supplyChain } from '@/mocks/smart-farm';

export default function SupplyChain() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="供应链协同"
          title={supplyChain.title}
          subtitle={supplyChain.desc}
        />

        {/* 物流路径 */}
        <Reveal className="mt-12">
          <div className="flex items-stretch justify-between gap-0 overflow-x-auto pb-2">
            {supplyChain.nodes.map((node, idx) => (
              <div key={node.title} className="relative flex flex-col items-center flex-1 min-w-[120px]">
                {idx < supplyChain.nodes.length - 1 && (
                  <div className="absolute top-7 left-1/2 w-full h-px bg-accent-300">
                    <i className="ri-arrow-right-line absolute -top-[7px] left-full -translate-x-1/2 text-accent-400 text-sm"></i>
                  </div>
                )}
                <div className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full bg-background-50 border-2 border-accent-400 text-accent-700 shrink-0">
                  <i className={`${node.icon} text-xl`}></i>
                </div>
                <div className="mt-3 text-sm font-semibold text-foreground-950 whitespace-nowrap">
                  {node.title}
                </div>
                <div className="mt-1 text-xs text-foreground-500 text-center leading-relaxed">
                  {node.desc}
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        {/* 能力卡片 */}
        <Reveal className="mt-12" delay={100}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {supplyChain.capabilities.map((cap) => (
              <div
                key={cap.title}
                className="p-6 rounded-lg bg-background-50 border border-background-200 transition-all duration-300 hover:-translate-y-1.5 hover:border-accent-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${cap.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-lg">{cap.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{cap.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-8" delay={140}>
          <div className="flex items-start gap-3 p-5 rounded-lg bg-background-50 border border-accent-200">
            <i className="ri-flow-chart text-accent-600 text-xl mt-0.5 shrink-0"></i>
            <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{supplyChain.note}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}